import store from "@/store";
import core from "@/core";

export default function() {
  return {
    data() {
      return {
        app: store.state.app,
        inFacilityId: null,
        inFacilityList: [],
      };
    },
    mounted() {
      this.$nextTick(async () => {
        core.loader.show();
        this.facilityList = await this.$store.dispatch("getFacilityList");
        this.refreshFacility();
        core.loader.hide();
      });
    },
    watch: {
      "app.facilityId"() {
        this.refreshFacility();
      },
    },
    methods: {
      async refreshFacility() {
        const app = this.app;
        if (app.facilityId != null) {
          core.loader.show();

          for (let i = 0; i < app.facilityList.length; i++) {
            const facility = app.facilityList[i];
            if (facility.id === app.facilityId) {
              this.inFacilityList = facility.inFacilityList;
              let inFacilityId = null;
              facility.inFacilityList.forEach((inFacility) => {
                inFacility.label = inFacility.dongNo + "동";
                inFacility.value = inFacility.id;
                if (inFacilityId == null) inFacilityId = inFacility.id;
              });
              this.inFacilityId = inFacilityId;
              break;
            }
          }
          core.loader.hide();
        }
      },
    },
  };
}
